<template>
    <ModalConfirm
        id="modal-confirm-request-penutupan-kas-kecil"
        title="Konfirmasi Ajukan EC"
        :isSubmitting="isSubmitting"
        alertVariant="danger"
        alertMessage="<i class='fa fa-exclamation-triangle mr-2'></i><strong>Perhatian:</strong> Mengajukan EC akan <strong>menutup Kas Kecil ini</strong>. Setelah diajukan, kas kecil tidak dapat digunakan sampai proses EC selesai."
        @submit="$emit('submit')"
    >
        <p>Apakah Anda yakin ingin mengajukan EC kas kecil ini?</p>
        <b-form-group label="Kas Kecil Saat Ini" class="mb-0">
            <b-input-group prepend="Rp.">
                <b-form-input
                    :value="currentCash"
                    name="kasKecilCurrentCashConfirmInput"
                    :disabled="isSubmitting"
                    @input="$emit('update:currentCash', $event)"
                />
            </b-input-group>
        </b-form-group>
        <b-form-group label="Catatan (Opsional)" class="mb-0 mt-3">
            <b-form-textarea
                :value="notes"
                name="kasKecilRequestPenutupanNotes"
                rows="3"
                maxlength="255"
                :disabled="isSubmitting"
                @input="$emit('update:notes', $event.trim())"
            />
            <small class="text-muted">{{ notes.length }}/255</small>
        </b-form-group>
    </ModalConfirm>
</template>

<script>
export default {
    name: "modal-kas-kecil-request-penutupan",
    props: {
        isSubmitting: { type: Boolean, default: false },
        currentCash: { type: String, default: "" },
        notes: { type: String, default: "" },
    },
}
</script>
